import { Menu } from '@mui/icons-material';
import React, { AppBar, IconButton, Toolbar, Typography } from '@mui/material';
import { useSharedState } from 'context';
import { ResponsiveAppBarProps } from './ResponsiveAppBarProps';

export const ResponsiveAppBar = (props: ResponsiveAppBarProps) => {
	const { sharedState, setSharedState } = useSharedState();
	const handleDrawerToggle = () => {
		setSharedState(!sharedState);
	};
	return (
		<AppBar position='fixed' sx={{ width: { sm: `calc(100% - ${props.drawerWidth}px)` } }}>
			<Toolbar>
				<IconButton color='inherit' aria-label='open drawer' edge='start' onClick={handleDrawerToggle} sx={{ display: { xs: 'block', sm: 'none' } }}>
					<Menu />
				</IconButton>
				<Typography variant='h5' noWrap component='div'>
					{props.title}
				</Typography>
			</Toolbar>
		</AppBar>
	);
};
